export class Separator {
    constructor() {
        this.separatorClass = 'separator';
        this.separatorBackgroundImageAttribute = 'data-separator';
        this.init();
    }
    init() {
        const separators = document.querySelectorAll('.separator');
        const separatorImage = document.body.getAttribute('data-separator');
        if(separators && separators.length > 0 && separatorImage && separatorImage != null) {
            for(let x = 0; x < separators.length; x++) {
                if(!separators[x].classList.contains('separator--no-margin-top')) {
                    separators[x].style.background = 'url('+separatorImage+') no-repeat center';
                    separators[x].style.border = 'none';
                    separators[x].style.width = '38px';
                    separators[x].style.height = '31px';
                } else {
                    separators[x].style.borderWidth = '1px';
                }
            }
        }
    }
}
